import { Verification } from './containers/email-verification/email-verification';

export default [
    {
        path: 'verify',
        children: [
            {
                path: 'email/:profileID/:token',
                element: <Verification />,
            },
        ],
    },
];
